
import makerjs from "makerjs";
function B18(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,T = Param[2].param,R = Param[3].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       t = T * 1 * myZoom,
        r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = 0, x1 = 0, x2 =t ,x3 =b , y0 = 0, y1 = l,y2 = r, y3 =0,glassH =l, glassW = b,h=l,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  }  if (r !== 0) {
    var TxtR = "R="+R;
  }  if (t !== 0) {
    var TxtT = "T="+T;
  } 



   var drawAbnormalShapeB18 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "RightLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "BottomLine": new makerjs.paths.Line([x3,y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeB18MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x0, y1], [x0- 2 * markShift, y1]),
        "RightShortDnline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB18MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x3+ markShift, y3], [x3+ markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x3, y2], [x3+ 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeB18MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x3, y3- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB18MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x1, y1+ markShift], [x2, y1+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x1, y1], [x1, y1 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y1], [x2, y1 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB18MarkB, TxtB, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB18MarkT, TxtT, [x1, y1+ 2*markShift], [x2, y1+ 2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB18MarkL, TxtL, [x0-2*markShift, y0], [x0-2*markShift, y1]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB18MarkR, TxtR, [x3+ 3*markShift, y3], [x3+ 3*markShift, y2]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB18: drawAbnormalShapeB18,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB18: drawAbnormalShapeB18,
        drawAbnormalShapeB18MarkL: drawAbnormalShapeB18MarkL,
        drawAbnormalShapeB18MarkT: drawAbnormalShapeB18MarkT,
        drawAbnormalShapeB18MarkR: drawAbnormalShapeB18MarkR,
        drawAbnormalShapeB18MarkB:drawAbnormalShapeB18MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B18;